import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard, MainComponent } from "@rubii/frontend-common";
import { SettingComponent } from "./account/setting/setting.component";
import { AppComponent } from "./app.component";
import { NavigateComponent } from "./account/navigate/navigate.component";
import { NoParamsComponent } from './account/datasource/_noparams/noparams.component';
import { DatasourcesComponent } from './account/datasource/datasources/datasources.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { LockComponent } from './lock/lock.component';
import { VerificationComponent } from './verification/verification.component';
import { CallbackComponent } from './callback/callback.component';
import { TestComponent } from './test/test.component';
import { UploadComponent } from './account/datasource/custom/upload/upload.component';
import { AnalysingComponent } from './account/datasource/custom/analysing/analysing.component';
import { SummaryComponent } from './account/datasource/custom/summary/summary.component';
import { GenerateMappingComponent } from './account/datasource/custom/generate-mapping/generate-mapping.component';
import { MappingResultComponent } from './account/datasource/custom/mapping-result/mapping-result.component';

const routes: Routes = [
    {
        path: 'login',
        component: AppComponent,
        children: [
            { path: '', component: LoginComponent },
        ]
    },
    {
        path: 'sso/callback',
        component: AppComponent,
        children: [
            { path: '', component: CallbackComponent },
        ]
    },
    {
        path: 'newpass/:token',
        component: AppComponent,
        children: [
            { path: '', component: LoginComponent },
        ]
    },
    {
        path: 'activate/:token',
        component: AppComponent,
        children: [
            { path: '', component: LoginComponent },
        ]
    },
    {
        path: 'settings',
        component: MainComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: SettingComponent },
            { path: ':typeId', component: NoParamsComponent},
        ]
    },
    {
        path: 'datasources',
        component: MainComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: DatasourcesComponent },
            { path: 'custom/upload', component: UploadComponent },
            { path: 'custom/analysing/:uuid', component: AnalysingComponent },
            { path: 'custom/summary/:uuid', component: SummaryComponent },
            { path: 'custom/generate-mapping/:uuid', component: GenerateMappingComponent },
            { path: 'custom/mapping-result/:uuid', component: MappingResultComponent }
        ]
    },
    {
        path: 'welcome',
        component: MainComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: NavigateComponent }
        ]
    },
    {
        path: 'maintenance',
        component: AppComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: MaintenanceComponent }
        ]
    },
    {
        path: 'lock',
        component: AppComponent,
        children: [
            { path: '', component: VerificationComponent }
        ]
    },
    {
        path: 'verificationlink/:token',
        component: AppComponent,
        children: [
            { path: '', component: VerificationComponent },
        ]
    },
    {
        path: 'verification',
        component: AppComponent,
        children: [
            { path: '', component: VerificationComponent },
        ]
    },
    {
        path: 'test',
        component: AppComponent,
        children: [
            { path: '', component: TestComponent },
        ]
    },
    { path: '**', redirectTo: '/settings' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
